var readSet = 0;
var writeSet = 0;
var deleteSet = 0;
var baseURL = '';
var adminUrl = '';
var currentSubCategory = '';
var filterSearchArray = ['sort','order','filter_status','filter_date_from','filter_date_to','filter_category', 'filter_code', 'filter_name', 'filter_mobile', 'filter_email', 'filter_product','filter_category_id','filter_manufacturer_id','filter_first_name','filter_email','filter_mobile','filter_verification_status', 'filter_log_message','filter_offer_name','filter_subject','filter_seo_url','filter_post_by','filter_campaign_name','filter_url','filter_title','filter_search_key','filter_rating','filter_date','filter_email_to','filter_description','filter_stock_number','filter_upc_code','filter_type'];


$(document).ready(function(){

  baseURL = funGetValueWe("txtBaseUrl"); 
  adminUrl = funGetValueWe("txtAdminUrl");
  var currentRoute = funGetValueWe("txtCurrentRoute");

   if (currentRoute === "tadmin/dashboard") {
    getCustomerMonthWiseLogData();
    pieChart();
    osPieChart();
    getCustomerLogData();
    bubbleChart();
    getMonthwiseData();
    gadgetsPieChart();
  }


  $('.date').datepicker({'autoHide':true,'format':'dd-mm-yyyy', 'todayHighlight': true});

  $('.auto-firearm').autocomplete({
      lookup: function (query, done) {
      $.ajax({                                // Ajax call
          type: "GET",
          dataType: "JSON",
          url: baseURL+adminUrl+"/ajax/auto-firearm-parts",
           data:'q='+query+'&sub_category='+currentSubCategory+'&manufacturer_id='+funGetValueWe("txtManufacturerId"),
              success: function(response) {
                var result = {
                    suggestions: response
                };
                done(result);
              },
              error: function() {
              funErrorMessage("Error occured !!! Please try after sometime.");
              }
      });
    },
    onSelect: function(suggestion) {
      funSetValue("txtDefaultPartId"+currentSubCategory, suggestion.data.id);
    },
    minChars: 1
  });

  $(".auto-firearm-filter").autocomplete({
      lookup: function (query, done) {
      $.ajax({                                // Ajax call
          type: "GET",
          dataType: "JSON",
          url: baseURL+adminUrl+"/ajax/auto-firearm-parts",
           data:'q='+query,
              success: function(response) {
                var result = {
                    suggestions: response
                };
                done(result);
              },
              error: function() {
              funErrorMessage("Error occured !!! Please try after sometime.");
              }
      });
    },
    onSelect: function(suggestion) {
      setFirearmFilter(suggestion.data)
    },
    minChars: 1
  });

  $('.auto-restricted-arms').autocomplete({
      lookup: function (query, done) {
      $.ajax({                                // Ajax call
          type: "GET",
          dataType: "JSON",
          url: baseURL+adminUrl+"/ajax/auto-firearm-parts",
           data:'q='+query,
              success: function(response) {
                var result = {
                    suggestions: response
                };
                done(result);
              },
              error: function() {
              funErrorMessage("Error occured !!! Please try after sometime.");
              }
      });
    },
    onSelect: function(suggestion) {
      setRestrictedArms(suggestion.data)
    },
    minChars: 1
  });

    $("#formResetPassword").submit(function(event){
      var password = funGetValueWe('txt_new_password');
      var confirm = funGetValueWe('txt_confirm_password');
      if(password != confirm) {
        fun_error_message("password and confirm does mot match");
      }
      else {
        $.ajax({                                // Ajax call
            type: "POST",
            dataType: "JSON",
            url: baseURL+adminUrl+"/ajax/reset-password",
             data:'_token='+funGetToken()+'&password='+password,
                success: function(response) {
                    if(response.status==true)
                    {   
                        // $("#span_log_count").css("display","none");
                        funSetValue("txt_new_password",'');
                        funSetValue("txt_confirm_password",'');
                        funCloseModal("modalResetPassword");
                        funSuccessMessage(response.message);
                    }
                    else
                    {
                        funErrorMessage(response.message);
                    }   
                },
            error: function() {
                funHideLoader();
                funErrorMessage("Error occured !!! Please try after sometime.");
            }
        });
      }
      event.preventDefault();
    });
});

function getCustomerMonthWiseLogData(){
   $.ajax({                                // Ajax call
      type: "GET",
      dataType: "JSON",
      url: baseURL+adminUrl+"/ajax/customer-month-wise-log",
      success: function(response) {
      if(response.status){
          loadChartData(response.data.builder);
          loadCheckoutChartData(response.data.builder,response.data.checkout);
      }          
      else
        funErrorMessage(response.message);   
      },
      error: function() {
          funErrorMessage("Error occured !!! Please try after sometime.");
      }              
  });
}

function loadChartData(responseData) {
  if (responseData) {
    var chartOneArrayLabel = [];
    var chartOneArrayCount = [];
    $.each(responseData, function (index, value) {
      chartOneArrayLabel.push(value['month']);
    });
    $.each(responseData, function (index, value) {
      chartOneArrayCount.push(value.count);
    });

    var ctx = document.getElementById("customer-monthly-log").getContext("2d");
    var myChart = new Chart(ctx, {
      type: "line",
      data: {
        labels : chartOneArrayLabel,
        datasets: [
          {
            label: "Gun Builder Accessed",
            data: chartOneArrayCount,
            backgroundColor: ["rgba(255, 99, 132, 0.2)"],
            borderColor: ["rgba(255,99,132,1)"],
            borderWidth: 1,
          },
        ],
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    });
  }
}

function loadCheckoutChartData(responseData1,responseData2) {
  if (responseData1) {
    var chartOneArrayLabel = [];
    var chartOneArrayCount = [];
    var chartTwoArrayLabel = [];
    var chartTwoArrayCount = [];
    $.each(responseData1, function (index, value) {
      chartOneArrayLabel.push(value['month']);
    });
    $.each(responseData1, function (index, value) {
      chartOneArrayCount.push(value.count);
    });

     $.each(responseData2, function (index, value) {
      chartTwoArrayLabel.push(value['month']);
    });
    $.each(responseData2, function (index, value) {
      chartTwoArrayCount.push(value.count);
    });

    var ctx = document.getElementById("checkout-monthly-log").getContext("2d");
    var myChart = new Chart(ctx, {
      type: "bar",
      data:
          {
            labels : chartOneArrayLabel,
            datasets: [
              {
                label: "Gun Builder Accessed",
                data: chartOneArrayCount,
                backgroundColor: ["rgb(255, 99, 132)"],
                borderColor: ["rgb(255, 99, 132)"],
                borderWidth: 1,
              },
              {
                label: "Check Out Accessed",
                data: chartTwoArrayCount,
                backgroundColor: ["RGB(99, 255, 222)"],
                borderColor: ["RGB(99, 255, 222)"],
                borderWidth: 1,
              },
            ],
          },
  
      options: {        
        responsive: true,
            scales: {
              x: {
                stacked: true,
              },
              y: {
                stacked: true
              }
          },
        },
      });
    }
}

function osPieChart() {
  $.ajax({                                // Ajax call
      type: "GET",
      dataType: "JSON",
      url: baseURL+adminUrl+"/ajax/dashboard/chart/os",
      success: function(response) {
      if(response.status){
        loadOSPieChartData(response.data);
      }          
      else
        funErrorMessage(response.message);   
      },
      error: function() {
          funErrorMessage("Error occured !!! Please try after sometime.");
      }              
  });
}

function loadOSPieChartData(data) {
    var ctx = document.getElementById("os-pie-chart").getContext("2d");
    var myChart = new Chart(ctx, {
      type: "pie",
      options: {
         responsive: true,
       },
      data: {
        labels : data.os,
        datasets: [
          {
            label: 'Browser  wise page view count',
            data: data.data,
            backgroundColor: data.colors,
            hoverOffset: 4
          },
        ],
      },      
    });
}

function pieChart(){
  

  $.ajax({                                // Ajax call
      type: "GET",
      dataType: "JSON",
      url: baseURL+adminUrl+"/ajax/dashboard/chart/browser",
      success: function(response) {
      if(response.status){
        loadPieChartData(response.data);
      }          
      else
        funErrorMessage(response.message);   
      },
      error: function() {
          funErrorMessage("Error occured !!! Please try after sometime.");
      }              
  });


}

function loadPieChartData(data) {
  console.log('pie-chart')
    var ctx = document.getElementById("pie-chart").getContext("2d");
    var myChart = new Chart(ctx, {
      type: "pie",
      options: {
         responsive: true,
       },
      data: {
        labels : data.browsers,
        datasets: [
          {
            label: 'Browser  wise page view count',
            data: data.data,
            backgroundColor: data.colors,
            hoverOffset: 4
          },
        ],
      },      
    });
}

function getCustomerLogData(){
   $.ajax({                                // Ajax call
      type: "GET",
      dataType: "JSON",
      url: baseURL+adminUrl+"/ajax/customer-log",
      success: function(response) {
      if(response.status){
          loadCustomerLogtData(response.data.registeredUser,response.data.notRegisteredUser);
      }          
      else
        funErrorMessage(response.message);   
      },
      error: function() {
          funErrorMessage("Error occured !!! Please try after sometime.");
      }              
  });
}

function loadCustomerLogtData(responseData1,responseData2) {
  if (responseData1) {
    var chartOneArrayLabel = [];
    var chartOneArrayCount = [];
    var chartTwoArrayLabel = [];
    var chartTwoArrayCount = [];
    $.each(responseData1, function (index, value) {
      chartOneArrayLabel.push(value['month']);
    });
    $.each(responseData1, function (index, value) {
      chartOneArrayCount.push(value.count);
    });

     $.each(responseData2, function (index, value) {
      chartTwoArrayLabel.push(value['month']);
    });
    $.each(responseData2, function (index, value) {
      chartTwoArrayCount.push(value.count);
    });

    var ctx = document.getElementById("customer-log").getContext("2d");
    var myChart = new Chart(ctx, {
      type: "bar",
      data:
          {
            labels : chartOneArrayLabel,
            datasets: [
              {
                label: "Registered User",
                data: chartOneArrayCount,
                backgroundColor: ["rgb(255, 205, 86)"],
                borderColor: ["rgb(255, 205, 86)"],  
                borderWidth: 1,
              },
              {
                label: "Not Registered User",
                data: chartTwoArrayCount,
                backgroundColor: ["rgb(255, 99, 132)"],
                borderColor: ["rgb(255, 99, 132)"],
                borderWidth: 1,
              },
            ],
          },
  
      options: {        
        responsive: true,
            scales: {
              x: {
                stacked: true,
              },
              y: {
                stacked: true
              }
          },
        },
      });
    }
}

function bubbleChart(){
  $.ajax({                                // Ajax call
      type: "GET",
      dataType: "JSON",
      url: baseURL+adminUrl+"/ajax/dashboard/chart/time-wise-page-view",
      success: function(response) {
      if(response.status){
        loadBubbleChartData(response.data);
      }          
      else
        funErrorMessage(response.message);   
      },
      error: function() {
          funErrorMessage("Error occured !!! Please try after sometime.");
      }              
  });

  
}

function loadBubbleChartData(data) {
  console.log('bubble-chart')

    var ctx = document.getElementById("bubble-chart").getContext("2d");
    var myChart = new Chart(ctx, {
      type: "bubble",
      options: {
         responsive: true,
       },
      data: {
        datasets: [{
          label: 'Page views',
          data: data.time_slots,
          // data: [{
          //   x: 20,
          //   y: 30,
          //   r: 15
          // }, {
          //   x: 40,
          //   y: 10,
          //   r: 10
          // }, {
          //   x: 60,
          //   y: 40,
          //   r: 20
          // }, {
          //   x: 30,
          //   y: 30,
          //   r: 5
          // }],
          backgroundColor: 'rgb(255, 99, 132)'
        }]
      },   
       options: {
        
      },   
    });
}




function formatDBDateToUsFormat(date) {
  var dateArr = date.split("-");
  return dateArr[1] + "/" + dateArr[2] + "/" + dateArr[0];
}

function fun_filter_search_submit()
{
  var redirect = funGetValueWe('redirect');
  var query_url = '';

  $(filterSearchArray).each(function(index,value){

    console.log(value+'-'+funGetValue(value));

      if(funGetValue(value)!='' ){
        console.log("coming in");
        // console.log(funGetValue(value));
        query_url = funSetQueryUrlValue(query_url,value,funGetValue(value));
      }

      if(funGetValue(value)==''){
        console.log("coming in 2");
        query_url = funRemoveUrlValue(query_url,value,funGetUrlParameter(value));
      }
      // console.log(query_url);
  });

  if(query_url == '')
    url = funGetValueWe('page_url');
  else
    url = funGetValueWe('page_url')+'?'+query_url;
  url = funUrlValidator(url);
  url = funUrlValidator(url);
  console.log('redirect url - '+url);
  window.location = url;
}


function fun_check_all(type)
{
  if(type=='read' && readSet == 0) {
    $(".checkRead").prop("checked",true);
    readSet = 1;
  }
  else if(type=='read' && readSet == 1) {
    $(".checkRead").prop("checked",false);
    readSet = 0;
  }

  if(type=='write' && writeSet == 0) {
    $(".checkWrite").prop("checked",true);
    writeSet = 1;
  }
  else if(type=='write' && writeSet == 1) {
    $(".checkWrite").prop("checked",false);
    writeSet = 0;
  }

  if(type=='delete' && deleteSet == 0) {
    $(".checkDelete").prop("checked",true);
    deleteSet = 1;
  }
  else if(type=='delete' && deleteSet == 1) {
    $(".checkDelete").prop("checked",false);
    deleteSet = 0;
  }

}

function funLogout()
{
    funOpenModal("modalSystemLogout");
}

function funOpenModal(id,arg)
{
  if(arg == true){
    $('#'+id).modal({backdrop: 'static', keyboard: false});
  }
   
  $("#" + id).modal("show");
  
}

function funCloseModal(id)
{
  $("#"+id).modal("hide");
}

function funLogoutConfirm()
{
    var base_url = funGetValueWe("txtBaseUrl");
    window.location = base_url+adminUrl+'/logout';
}

function funGetValueWe(id)
{
  return $.trim($("#"+id).val());
}

function funGetToken()
{
    return $("input[name=_token]").val();
}

function funShowLoader()
{
  $('body').addClass('loading').addClass('overlay').loader('show', {
      loader: false,
    overlay: true
  });
  return true;
}

function funHideLoader()
{
  $('body').removeClass('loading').loader('hide');
  return true;
}

function funSuccessMessage(msg)
{
     toastr.clear();
      toastr.options = {
      "closeButton": false,
      "debug": false,
      "newestOnTop": false,
      "progressBar": true,
      "positionClass": "toast-bottom-center",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "5000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }
    toastr.success(msg);
    return true;
}

function funErrorMessage(msg) {
    toastr.clear();
   toastr.options = {
      "closeButton": false,
      "debug": false,
      "newestOnTop": false,
      "progressBar": true,
      "positionClass": "toast-bottom-center",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "5000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }
    toastr.error(msg);
    return true;
}

function funSetAdminLeftBar()
{
  var token = $("input[name='_token']").val();
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/ajax/set-admin-left-menu",
    data: '_token='+token,
    success: function(response) {
        
    },
    error: function() {
      console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funSetValue(id,value)
{
  $("#"+id).val(value);
}

function funGetValue(id)
{
  return encodeURIComponent($.trim($("#"+id).val()));
}

function funFilterSearchSubmit()
{
  var redirect = funGetValueWe('redirect');
  var query_url = '';

  $(filterSearchArray).each(function(index,value){

    console.log(value +' - ' +funGetValue(value));

      if(funGetValue(value)!='' ){
        console.log("coming in");
        // console.log(funGetValue(value));
        query_url = funSetQueryUrlValue(query_url,value,funGetValue(value));
      }

      if(funGetValue(value)==''){
        console.log("coming in 2");
        query_url = funRemoveUrlValue(query_url,value,funGetUrlParameter(value));
      }

      // console.log(query_url);
  });

  if(query_url == '')
    url = funGetValueWe('page_url');
  else
    url = funGetValueWe('page_url')+'?'+query_url;
  url = funUrlValidator(url);
  url = funUrlValidator(url);
  console.log('redirect url - '+url);
  window.location = url;
}

function funSetQueryUrlValue(query_url,parameter_name,parameter_value)
{
  // console.log('parameter Value - '+parameter_value);
  if(query_url == '')
      query_url = parameter_name+'='+parameter_value;
    else
      query_url = query_url+'&'+parameter_name+'='+parameter_value;
    return query_url;
}

function funUrlValidator(url)
{
  url = url.replace('?&','?');
  url = url.replace('&&','&');
  url = url.replace('&&&','&');
  return url.replace(/&&+$/,'');
}

function funRemoveUrlValue(query_url,name,value)
{
  para_value = name+'='+value;
  query_url = query_url.replace(para_value,'');
  query_url = query_url.replace(/&+$/,'');
  return query_url.replace(/&&+$/,'');
}

function funGetUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}

function funTableRowStatusChange(id,type)
{
  var menuUrl = funGetValueWe("txtMenuUrl");
  var token = $("input[name='_token']").val();
  $.ajax({                // Ajax call
    type: "POST",
    url: baseURL+adminUrl+"/ajax/change-status",
    data: '_token='+token+'&menu_url='+menuUrl+'&id='+id,
    success: function(response) {
      if(response.status) {
            
        var currentRoute = funGetValueWe("txtCurrentRoute");
        if(currentRoute === 'tadmin/store') {
          location.reload();
          return;
        }
        funSuccessMessage(response.message);
        if(type == 2){
          if(response.data.update == 1) 
            $("#divStatus"+id).html('<a class="badge badge-success text-white"> Yes </a>');
          else 
            $("#divStatus"+id).html('<a class="badge badge-danger text-white"> No </a>');
        }
        else{
           if(response.data.update == 1) 
            $("#divStatus"+id).html('<a class="badge badge-success text-white"> Enabled </a>');
          else 
            $("#divStatus"+id).html('<a class="badge badge-danger text-white">Disabled</a>');           
        }
       
      }
      else {
       funErrorMessage(response.message); 
      }
        
    },
    error: function() {
      console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funTableRowUpdate(id,type)
{
  var menuUrl = funGetValueWe("txtMenuUrl");
  var token = $("input[name='_token']").val();
  $.ajax({                // Ajax call
    type: "POST",
    url: baseURL+adminUrl+"/ajax/row/update",
    data: '_token='+token+'&menu_url='+menuUrl+'&id='+id,
    success: function(response) {      
      if(response.status) {
        
        var currentRoute = funGetValueWe("txtCurrentRoute");
        if(currentRoute === 'tadmin/catalog/manufacturer') {
          location.reload();
          return;
        }       
        funSuccessMessage(response.message); 
        if(type == 2){
          if(response.data.update == 1) 
            $("#divRowUpdate"+id).html('<a class="badge badge-success text-white"> Yes </a>');
          else 
            $("#divRowUpdate"+id).html('<a class="badge badge-danger text-white"> No </a>');
        }
        else{
           if(response.data.update == 1) 
            $("#divRowUpdate"+id).html('<a class="badge badge-success text-white"> Enabled </a>');
          else 
            $("#divRowUpdate"+id).html('<a class="badge badge-danger text-white">Disabled</a>');           
        }
       
      }
      else {
       funErrorMessage(response.message); 
      }
        
    },
    error: function() {
      console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funSetCurrentID(id)
{
  currentSubCategory = id;
}

function prettyPrint(id) {
    var ugly = document.getElementById(id).value;
    var obj = JSON.parse(ugly);
    var pretty = JSON.stringify(obj, undefined, 4);
    document.getElementById(id).value = pretty;
}

function funClearDefaultPartId(id)
{
  funSetValue("txtDefaultPartId"+id, "");
}

function setRestrictedArms(data)
{
  funSetValue("restricted_parts", "");
  var template = '<div id="restricted-part-'+data.id+'">  <i onclick="funRemoveRestrictedPart('+data.id+')" class="fa fa-minus-circle"></i> '+data.upc_code+' -> '+data.item_desc+' <input type="hidden" name="restricted_part[]" value="'+data.id+'">  </div>'
  $("#div-restricted-parts").append(template);
}

function funRemoveRestrictedPart(id)
{
  $("#restricted-part-"+id).remove();
}

function setFirearmFilter(data)
{
  funSetValue("firearm_part", "");
  var template = '<div id="firearm-filter-part-'+data.id+'">  <i onclick="funRemoveFirearmFilterPart('+data.id+')" class="fa fa-minus-circle"></i> '+data.upc_code+' -> '+data.item_desc+' <input type="hidden" name="filter_parts[]" value="'+data.id+'">  </div>'
  $("#div-firearm-filter-parts").append(template); 
}

function funRemoveFirearmFilterPart(id)
{
  $("#firearm-filter-part-"+id).remove();
}

function fun_test_email(id)
{
  fun_open_modal('modal_test_email_content');
  contentID = id;
}

function fun_open_modal(id,arg)
{
  if(arg == true){
    $('#'+id).modal({backdrop: 'static', keyboard: false});
  }
   
  $("#" + id).modal("show");
  
}

function fun_close_modal(id)
{
  $("#"+id).modal("hide");
}

function fun_test_sms(id)
{
  fun_open_modal('modal_test_sms_content');
  contentID = id;
}

function fun_hide_modal_loader()
{
  $(".modal-footer i").css("display","none");
  fun_modal_clear_msg();
}

$(".auto-rsr-category").autocomplete({
      lookup: function (query, done) {
      $.ajax({                                // Ajax call
          type: "GET",
          dataType: "JSON",
          url: baseURL+adminUrl+"/ajax/auto-rsr-category",
           data:'q='+query,
              success: function(response) {
                var result = {
                    suggestions: response
                };
                done(result);
              },
              error: function() {
              funErrorMessage("Error occured !!! Please try after sometime.");
              }
      });
    },
    onSelect: function(suggestion) {
      setRsrCategory(suggestion.data)
    },
    minChars: 1
  });

function setRsrCategory(data)
{
  funSetValue("rsr-category", "");
  var template = '<div id="rsr-category'+data.id+'">  <i onclick="funRemoveRSRCategory('+data.id+')" class="fa fa-minus-circle"></i> '+data.name+' <input type="hidden" name="categories[]" value="'+data.id+'">  </div>'
  $("#div-rsr-category").append(template); 
}

function funRemoveRSRCategory(id)
{
  $("#rsr-category"+id).remove();
}

$(".auto-rsr-product").autocomplete({
      lookup: function (query, done) {
      $.ajax({                                // Ajax call
          type: "GET",
          dataType: "JSON",
          url: baseURL+adminUrl+"/ajax/auto-rsr-product",
           data:'q='+query,
              success: function(response) {
                var result = {
                    suggestions: response
                };
                done(result);
              },
              error: function() {
              funErrorMessage("Error occured !!! Please try after sometime.");
              }
      });
    },
    onSelect: function(suggestion) {
      setRsrProduct(suggestion.data)
    },
    minChars: 1
  });

function setRsrProduct(data)
{
  funSetValue("rsr-product", "");
  var template = '<div id="rsr-product'+data.id+'">  <i onclick="funRemoveRSRProduct('+data.id+')" class="fa fa-minus-circle"></i> '+data.stock_number+' <input type="hidden" name="products[]" value="'+data.id+'">  </div>'
  $("#div-rsr-product").append(template); 
}

function funRemoveRSRProduct(id)
{
  $("#rsr-product"+id).remove();
}

$(".auto-customer-name").autocomplete({
      lookup: function (query, done) {
      $.ajax({                                // Ajax call
          type: "GET",
          dataType: "JSON",
          url: baseURL+adminUrl+"/ajax/auto-customer-name",
           data:'q='+query,
              success: function(response) {
                var result = {
                    suggestions: response
                };
                done(result);
              },
              error: function() {
              funErrorMessage("Error occured !!! Please try after sometime.");
              }
      });
    },
    onSelect: function(suggestion) {
      console.log(suggestion.data.id);
      funSetValue("customer_id", suggestion.data.id);
    },
    minChars: 1
  });

function getMonthwiseData(){
   $.ajax({                                // Ajax call
      type: "GET",
      dataType: "JSON",
      url: baseURL+adminUrl+"/ajax/dashboard/chart/month-wise-order",
      success: function(response) {
      if(response.status){
          loadMonthwiseOrderData(response.data.monthwiseOrder);
      }          
      else
        funErrorMessage(response.message);   
      },
      error: function() {
          funErrorMessage("Error occured !!! Please try after sometime.");
      }              
  });
}

function loadMonthwiseOrderData(responseData1) {
  if (responseData1) {
    var chartOneArrayLabel = [];
    var chartOneArrayCount = [];
    
    $.each(responseData1, function (index, value) {
      chartOneArrayLabel.push(value['month']);
    });
    $.each(responseData1, function (index, value) {
      chartOneArrayCount.push(value.count);
    });

    var ctx = document.getElementById("month-wise-order").getContext("2d");
    var myChart = new Chart(ctx, {
      type: "bar",
      data:
          {
            labels : chartOneArrayLabel,
            datasets: [
              {
                label: "Monthwise Order",
                data: chartOneArrayCount,
                backgroundColor: ["rgb(54, 162, 235)"],
                borderColor: ["rgb(54, 162, 235)"],  
                borderWidth: 1,
              },             
            ],
          },
  
      options: {        
        responsive: true,
            scales: {
              x: {
                stacked: true,
              },
              y: {
                stacked: true
              }
          },
        },
    });
  }
}

function gadgetsPieChart(){
  $.ajax({                                // Ajax call
      type: "GET",
      dataType: "JSON",
      url: baseURL+adminUrl+"/ajax/dashboard/chart/gadgets",
      success: function(response) {
      if(response.status){
        loadGadgetsPieChartData(response.data);
      }          
      else
        funErrorMessage(response.message);   
      },
      error: function() {
          funErrorMessage("Error occured !!! Please try after sometime.");
      }              
  });
}

function loadGadgetsPieChartData(data) {
  console.log('pie-chart')
    var ctx = document.getElementById("gadgets").getContext("2d");
    var myChart = new Chart(ctx, {
      type: "pie",
      options: {
         responsive: true,
       },
      data: {
        labels : data.gadget,
        datasets: [
          {
            label: 'Gadgets',
            data: data.data,
            backgroundColor: data.colors,
            hoverOffset: 4
          },
        ],
      },      
    });
}
